var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AuthenticationManager_instance, _AuthenticationManager_props, _AuthenticationManager_acquireDefaultTokenSilent, _AuthenticationManager_acquireTokenSilent;
import { BrowserCacheLocation, PublicClientApplication } from "@azure/msal-browser";
import { isNullOrEmpty } from "../utilities";
export class AuthenticationManager {
    constructor(props) {
        _AuthenticationManager_instance.set(this, void 0);
        _AuthenticationManager_props.set(this, void 0);
        _AuthenticationManager_acquireDefaultTokenSilent.set(this, async (module) => {
            return __classPrivateFieldGet(this, _AuthenticationManager_acquireTokenSilent, "f").call(this, module, `${this.clientId}/.default`);
        });
        _AuthenticationManager_acquireTokenSilent.set(this, async (module, scope) => {
            if (this.useMsal) {
                const request = { scopes: [scope], account: __classPrivateFieldGet(this, _AuthenticationManager_instance, "f").getActiveAccount() };
                try {
                    const response = await __classPrivateFieldGet(this, _AuthenticationManager_instance, "f").acquireTokenSilent(request);
                    return response.accessToken;
                }
                catch (error) {
                    try {
                        const response = await __classPrivateFieldGet(this, _AuthenticationManager_instance, "f").acquireTokenPopup(request);
                        return response.accessToken;
                    }
                    catch (error) {
                        throw error;
                    }
                }
            }
            else {
                return __classPrivateFieldGet(this, _AuthenticationManager_props, "f").onGetAccessToken(module, scope);
            }
        });
        __classPrivateFieldSet(this, _AuthenticationManager_props, props, "f");
        if (props.useMsal) {
            __classPrivateFieldSet(this, _AuthenticationManager_instance, new PublicClientApplication({
                auth: {
                    clientId: props.clientId || '51606deb-babb-4619-9b45-46fdc9844f69',
                    authority: `https://login.microsoftonline.com/${props.tenantId}`,
                    redirectUri: window.location.origin,
                    skipAuthorityMetadataCache: false
                },
                cache: {
                    cacheLocation: BrowserCacheLocation.SessionStorage,
                    storeAuthStateInCookie: true,
                    secureCookies: true
                }
            }), "f");
        }
    }
    get useMsal() {
        const isMsal = __classPrivateFieldGet(this, _AuthenticationManager_props, "f").useMsal == null || __classPrivateFieldGet(this, _AuthenticationManager_props, "f").useMsal === true;
        return isMsal;
    }
    get instance() {
        return __classPrivateFieldGet(this, _AuthenticationManager_instance, "f");
    }
    get tenantId() {
        return __classPrivateFieldGet(this, _AuthenticationManager_props, "f").tenantId;
    }
    get clientId() {
        var _a;
        return (_a = __classPrivateFieldGet(this, _AuthenticationManager_props, "f").clientId) !== null && _a !== void 0 ? _a : '51606deb-babb-4619-9b45-46fdc9844f69';
    }
    getAccessToken(module, scope = '') {
        return isNullOrEmpty(scope) ? __classPrivateFieldGet(this, _AuthenticationManager_acquireDefaultTokenSilent, "f").call(this, module) : __classPrivateFieldGet(this, _AuthenticationManager_acquireTokenSilent, "f").call(this, module, scope);
    }
    getHeaders(module) {
        var _a, _b;
        return (_b = (_a = __classPrivateFieldGet(this, _AuthenticationManager_props, "f")).onGetHeaders) === null || _b === void 0 ? void 0 : _b.call(_a, module);
    }
    getApimKey(module) {
        var _a, _b;
        return (_b = (_a = __classPrivateFieldGet(this, _AuthenticationManager_props, "f")).onGetApimKey) === null || _b === void 0 ? void 0 : _b.call(_a, module);
    }
    loginPopup() {
        __classPrivateFieldGet(this, _AuthenticationManager_instance, "f").loginPopup({
            scopes: [`${this.clientId}/.default`]
        }).then(result => {
            __classPrivateFieldGet(this, _AuthenticationManager_instance, "f").setActiveAccount(result.account);
        });
    }
    loginRedirect() {
        __classPrivateFieldGet(this, _AuthenticationManager_instance, "f").loginRedirect({
            scopes: [`${this.clientId}/.default`],
            redirectUri: window.location.origin
        });
    }
}
_AuthenticationManager_instance = new WeakMap(), _AuthenticationManager_props = new WeakMap(), _AuthenticationManager_acquireDefaultTokenSilent = new WeakMap(), _AuthenticationManager_acquireTokenSilent = new WeakMap();
